import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, Lock } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Logo } from "../components/site/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("iph_token", data?.token ?? "");
      nav("/admin");
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grain flex min-h-screen items-center justify-center bg-ink px-5" data-testid="admin-login-page">
      <div className="hero-glow" />
      <motion.form
        onSubmit={submit}
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="relative w-full max-w-md rounded-[28px] border border-white/10 bg-card p-8 sm:p-10"
        data-testid="admin-login-form"
      >
        <Link to="/" data-testid="admin-login-home-link"><Logo /></Link>
        <div className="mt-10 flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-orange-300"><Lock size={14} /> Admin control centre</div>
        <h1 className="mt-3 font-display text-3xl font-bold text-white">Sign in</h1>
        <label className="mt-8 block">
          <span className="text-xs uppercase tracking-wider text-slate-400">Email</span>
          <input type="email" required className="field mt-2" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" />
        </label>
        <label className="mt-6 block">
          <span className="text-xs uppercase tracking-wider text-slate-400">Password</span>
          <input type="password" required className="field mt-2" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" />
        </label>
        {err && <p className="mt-5 rounded-lg bg-red-500/10 px-3 py-2 text-sm text-red-300" data-testid="admin-login-error">{err}</p>}
        <button type="submit" disabled={busy} className="btn-primary btn-lg mt-8 w-full justify-center" data-testid="admin-login-submit">
          {busy ? <Loader2 size={18} className="animate-spin" /> : "Sign in"}
        </button>
      </motion.form>
    </div>
  );
}
